export default "__VITE_ASSET__e_kcj5T5__"